var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.75 37.5C75.75 58.2105 58.9605 75 38.25 75C17.5395 75 0.75 58.2105 0.75 37.5C0.75 37.5089 38.25 0.00410156 38.25 0C58.9605 0 75.75 16.7895 75.75 37.5Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1494 37.5H38.2498C38.2498 37.4663 38.2498 37.4335 38.2498 37.3997C38.2164 37.4332 38.183 37.4666 38.1494 37.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 19.5652C38.25 12.9668 38.25 8.64331 38.25 0H38.2437C17.5359 0.00351563 0.75 16.7914 0.75 37.5H20.3152V26.4828L31.3326 37.5H38.1498C38.1832 37.4666 38.2167 37.4332 38.2501 37.3997C38.2501 34.8732 38.2501 32.619 38.2501 30.5827L27.2326 19.5652H38.25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7218 4.89136C13.8567 8.23106 8.98081 13.1069 5.64111 18.972V37.5001H15.4238V14.6743V14.674H38.2499C38.2499 11.5886 38.2499 8.64927 38.2499 4.89136H19.7218Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2501 32.8886L24.9269 19.5654C24.9269 19.5654 20.3154 19.5657 20.3154 19.5654V19.5657L38.2499 37.5001H38.2501C38.2501 37.5001 38.2501 34.3204 38.2501 32.8886Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6906 27.8262L66.5 30.3173H69.1192L67.0002 31.8568L67.8097 34.3478L65.6906 32.8084L63.5714 34.3478L64.3809 31.8568L62.2617 30.3173H64.881L65.6906 27.8262Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3276 45.7607L57.5419 49.4976H61.4707L58.292 51.8067L59.5064 55.5434L56.3276 53.2341L53.1489 55.5434L54.3633 51.8067L51.1846 49.4976H55.1134L56.3276 45.7607Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6812 16.4131L57.6931 19.5272H60.9672L58.3182 21.4513L59.3301 24.5652L56.6812 22.6406L54.0325 24.5652L55.0442 21.4513L52.3955 19.5272H55.6694L56.6812 16.4131Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6719 27.7175L48.8859 31.4543H52.8149L49.6362 33.7635L50.8506 37.5002L47.6719 35.1909L44.4932 37.5002L45.7075 33.7635L42.5288 31.4543H46.4577L47.6719 27.7175Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNewZealand);
export default __webpack_public_path__ + "static/media/flagNewZealand.ae68d337ae8cd77e36c67ef872c1c31c.svg";
export { ForwardRef as ReactComponent };